module.exports = __webpack_public_path__ + "assets/img/34_787_big.8a99b77e.jpg";